import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    buttonTitle: '',
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
  activeItem: {},
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    serviceStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};

      state.blockContent = {
        buttonTitle: blockContent.buttonTitle ?? '',
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    serviceClear: () => initialState,

    serviceUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    serviceUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    serviceUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    serviceUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },

    serviceUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const { serviceStore, serviceClear, serviceUpdateIsLoading, serviceUpdateIsActive, serviceUpdateBlockContent, serviceUpdateBlockDesign, serviceUpdateActiveItem } =
  serviceSlice.actions;

export const selectServiceIsLoading = (state) => state.service.isLoading;

export const selectServiceId = (state) => state.service.id;
export const selectServiceUID = (state) => state.service.uid;
export const selectServiceSID = (state) => state.service.sid;

export const selectServiceBlockContent = (state) => state.service.blockContent;
export const selectServiceBlockDesign = (state) => state.service.blockDesign;
export const selectServiceSortItems = createSelector([selectServiceBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectServiceItemDesign = (state) => state.service.itemDesign;
export const selectServiceButtonDesign = (state) => state.service.buttonDesign;
export const selectServiceContainerDesign = (state) => state.service.containerDesign;

export const selectServiceActiveItem = (state) => state.service.activeItem;

export default serviceSlice.reducer;
